import type { BaseEntity } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { DetailActionContext } from "@/contexts/DetailActionContext";
import {
  extractCompanyId,
  extractCompanyName,
  extractContactId,
  hasContactInfo,
} from "@/utils/entity-type-guards";

export type CompanyModalData = {
  contact?: {
    id: string;
    company_id?: string;
    company_name?: string;
  };
  company?: {
    id: string;
    name: string;
  };
};

export function buildCompanyModalData(
  item: Record<string, unknown>,
  context: DetailActionContext<BaseEntity>
): CompanyModalData {
  const entityName = context?.pageConfig?.entityName;

  const companyId =
    context?.entityIds?.companyId ?? extractCompanyId(item) ??
    (entityName === "companies" && typeof item.id === "string" ? item.id : undefined);

  const companyName =
    extractCompanyName(item) ??
    (entityName === "companies" && typeof item.name === "string" ? item.name : undefined);

  const company =
    companyId && companyName ? { id: companyId, name: companyName } : undefined;

  const isContactEntity = entityName === "contacts" || hasContactInfo(item);
  const contactId = isContactEntity ? extractContactId(item) : undefined;

  const contact =
    contactId && isContactEntity
      ? {
          id: contactId,
          company_id: companyId,
          company_name: companyName,
        }
      : undefined;

  return { contact, company };
}
